module.exports = __webpack_public_path__ + "static/Alice_Descamps-b9541ccebdd39d003c75e9eb14ba4161.webp";